import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1GroupJoin extends BaseOutgoingPayload {
  public readonly payload: V1GroupJoinPayload;

  constructor(groupCode: string) {
    super(OutgoingPayloadEvent.V1_GROUP_JOIN);
    this.payload = new V1GroupJoinPayload(groupCode);
  }
}

class V1GroupJoinPayload {
  public readonly group_code: string;

  constructor(group_code: string) {
    this.group_code = group_code;
  }
}
